import IconMessage from 'Features/Core/Components/IconMessage/IconMessage';
import ModelButton from 'Features/Core/Components/ModelButton/ModelButton';
import { useMemo, useState } from 'react';
import ContentMessageLoader from './ContentMessageLoader';

const TabView = ({ message, loading }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectedMessage = useMemo(() => {
    return Array.isArray(message) ? message[selectedIndex] : message;
  }, [selectedIndex, message]);

  return (
    <div className="w-full h-full flex gap-2">
      <IconMessage message={message} modelSelected={selectedMessage?.model} />
      <div className={`pb-1 pt-0 w-full ${'border-b border-cool-gray'}`}>
        <div className="w-full flex pt-2 justify-between">
          <div className="flex flex-1 flex-wrap gap-2">
            {Array.isArray(message) ? (
              message?.map((ele, idx) => (
                <div className="relative" key={idx}>
                  <ModelButton
                    model={ele?.model}
                    message={ele}
                    isFinished={ele?.finished}
                    isSelected={selectedMessage === ele}
                    onClick={() => setSelectedIndex(idx)}
                  />
                </div>
              ))
            ) : (
              <div className="relative">
                <ModelButton
                  model={message?.model}
                  message={message}
                  isFinished={message?.finished}
                  isSelected
                />
              </div>
            )}
          </div>
        </div>
        <div className="chat-container mt-3">
          <div className="w-full">
            <ContentMessageLoader
              message={selectedMessage}
              loading={loading}
              modelsIds={Array.isArray(message) ? message.map((m) => m.modelRef) : []}
            />
          </div>
        </div>
        <style>
          {`
        .latex-block {
          display: block;
          margin: 1em auto;
          text-align: center;
          overflow-x: auto;
          padding: 10px;
          width: 92%;
        }

        .latex-inline {
          display: inline;
          margin: 0;
          overflow-x: visible;
        }

        .latex-block::-webkit-scrollbar-thumb {
          border-radius: 10px;
        }
      `}
        </style>
      </div>
    </div>
  );
};

export default TabView;
